define('responsive-pitch-fx/lib/render/Canvas',['require','exports','module','Responsive/vendor','../helpers/domHelper','../helpers/Scaler','gesso/gesso','../math/gcd','../enums/config','../helpers/cssClass'],function(require,exports,module){
	var vendor = require( 'Responsive/vendor' ),
		domHelper = require( '../helpers/domHelper' ),
		Scaler = require('../helpers/Scaler'),
		gesso = require( 'gesso/gesso' ),
		gcd = require( '../math/gcd' ),
		config = require( '../enums/config' ),
		cssClass = require( '../helpers/cssClass' );

    var lineCap = "round",
        lineJoin = "miter";

    function RenderCanvas(pitchLayer){
    	
    	this.pitchLayer=pitchLayer;
    	this.scalers=pitchLayer.scalers;

        this.canvas_bg = document.createElement('canvas');
        this.canvas_fg = document.createElement('canvas');
        if(this.fadeOldPitches){
            this.canvas_history = document.createElement('canvas');        
        }
        
        if(!this.canvas_fg.getContext){
        	this.isCanvas=false;
        }
        this.gtx_bg = gesso(this.canvas_bg);
        this.ctx_bg = this.gtx_bg._ctx_;
        this.canvas_bg.style.opacity = 0.1;
        this.canvas_bg.className = cssClass("render") + " " + cssClass("trails");

        this.gtx_fg = gesso(this.canvas_fg);
        this.ctx_fg = this.gtx_fg._ctx_;
        this.canvas_fg.style.opacity = 0.1;
        this.canvas_fg.className = cssClass("render") + " " + cssClass("strikezone");

        if(config.fadeOldPitches){

            this.gtx_history = gesso(this.canvas_history);
            this.ctx_history = this.gtx_history._ctx_;
            this.canvas_history.style.opacity = 0.1;
            this.canvas_history.className = cssClass("render") + " " + cssClass("history");
        }

        this.gtx_bg.globalAlpha(1)
            .globalCompositeOperation("source-over")
            .miterLimit(1);

        if (~~this.ctx_bg[vendor.id + 'BackingStorePixelRatio'] > 1) {
            Scaler.prototype.canvasDensity = 1;
        }

        if (this.pitchLayer.scalers.canvasDensity >= 1) {
            this.canvas_bg.style[vendor.transitionJS] = "opacity 500ms ease-in 0";
            this.canvas_fg.style[vendor.transitionJS] = "opacity 500ms ease-in 0";
            if(config.fadeOldPitches){
                this.canvas_history.style[vendor.transitionJS] = "opacity 500ms ease-in 0";
            }
        }
    }

    RenderCanvas.prototype={
    	isCanvas 		  : true,
        isStrikeZoneDrawn : false,
        hidden          : true,
        anchor 			: function(){
            if(this.canvas_history){
                domHelper.append(this.pitchLayer.view,this.canvas_history);
            }
            domHelper.append(this.pitchLayer.view,this.canvas_bg);
            domHelper.append(this.pitchLayer.view,this.canvas_fg);
        },
        destroy 		: function(){
            domHelper.remove(this.canvas_history);
        	domHelper.remove(this.canvas_bg);
        	domHelper.remove(this.canvas_fg);
        },
        resize 			: function(){
            this.canvas_bg.height = this.scalers.height;
            this.canvas_bg.width = this.scalers.width;
            this.canvas_fg.height = this.scalers.height;
            this.canvas_fg.width = this.scalers.width;
            if(this.canvas_history){
                this.canvas_history.height = this.scalers.height;
                this.canvas_history.width = this.scalers.width;
            }
        },
        getSizerURI 	: function(){
			var scalers=this.pitchLayer.scalers,
            	mindims = gcd(this.scalers.base_width, this.scalers.base_height);

            this.canvas_fg.width = this.scalers.base_width / mindims;
            this.canvas_fg.height = this.scalers.base_height / mindims;

            this.gtx_fg.beginPath()
                .clearRect(0, 0, this.canvas_fg.width, this.canvas_fg.height)
                .closePath();
            
            return this.canvas_fg.toDataURL();

        },
        draw2Dpitch : function (pitch) {
        	var scalers=this.scalers;
        	var that=this;

            if (!this.isStrikeZoneDrawn) {
                this.draw2DStrikeZone(pitch);
            }

            if (scalers.mode === '2d' && pitch.is3DPitch) {
                this.pitchLayer.drawBall(pitch, pitch.getArrayOfPointsForPitch(1).slice(-1)[0]);
                return;
            }

            this.pitchLayer.drawBall(pitch,pitch.raster.points2D());
        },

        drawPitch : function (pitch) {
        	var that=this,
        		scalers=this.scalers;

            if (this.scalers.mode === '2d' || !pitch.is3DPitch) {
                this.draw2Dpitch(pitch);
                return;
            }
            if (!this.isStrikeZoneDrawn) {
                this.drawStrikeZone(pitch);
            }       
            // 3D Perspective Path
            this.drawPitchPath(pitch);
        },
        drawBall : function (pitch, pt) {
            if(config.domBalls){
                return;
            }
            var that=this,
            	scalers=this.pitchLayer.scalers,
                color = pitch.shader.ball,
                s_offset = 2 / scalers.base_width * scalers.x,
                fsize = ( 70 / scalers.base_width * scalers.fakeBallSize).toFixed(2),
                font = 'bold ' + fsize + 'em ' + config.font,
	            lineWidth = pt[4] || 0;

            this.gtx_fg.globalAlpha(1)
                .globalCompositeOperation("source-over")
                .beginPath()
                .arc(pt[0], pt[1] + scalers.fakeBallSize / 2, scalers.fakeBallSize, 0, (Math.PI / 180) * 360, true)
                .shadow({
                    offsetX: s_offset,
                    offsetY: s_offset,
                    blur: 4
                })
                .stroke({
                    style: pitch.shader.ballStroke
                })
                .shadowColor('transparent')
                .lineWidth(scalers.canvasDensity > 1 ? scalers.canvasDensity : 1);

            /* Fill solid first to avoid transparency bug in Android */
            this.gtx_fg.fillStyle(color)
                .fill()
                .stroke()
                .closePath()
                .beginPath()
                .font(font)
                .fillStyle(pitch.shader.text)
                .shadow({
                    offsetX: scalers.canvasDensity,
                    offsetY: scalers.canvasDensity,
                    blur: 1
                })
                .text({
                    align: "center",
                    baseline: "middle"
                })
                .fillText(pitch.num || " " + "", pt[0], pt[1] + scalers.fakeBallSize / 2)
                .closePath();
        },

        drawPitchStart : function (pt) {
            this.gtx_bg.beginPath()
                .lineWidth(1)
                .strokeStyle(colors.text)
                .arc(pt[0], pt[1], 6, 0, (Math.PI / 180) * 360, false)
                .stroke()
                .closePath();
        },

        drawPitchPath : function (pitch) {
            var that=this,
            	points=pitch.getArrayOfPoints(this.scalers.numberOfAnimationPoints),
            	start,
            	finish,
            	len = points.length,
                drawIn = this.scalers.timing;

           	points.forEach(function(finish,index){
           		if(index!==0){
		            that.pitchLayer.scheduler.addAction(function () {
						that.drawPitchPathFragment(pitch, points[index-1], finish);           		
					}, drawIn, that);
           		}
           	});

            if(this.pitchLayer.type !== 'side') {
	            this.pitchLayer.scheduler.addAction(function () {
	                this.pitchLayer.drawBall(pitch, points[len-1]);
    			}, drawIn, this);
            }
        },
        drawPitchPathFragment : function(pitch,pt1,pt2){
            var	color = pitch.shader.fill,
                lineWidth = pt2[3];
            this.gtx_bg.beginPath()
                //.globalCompositeOperation('copy')
                //.globalAlpha(0.8)
                .miterLimit(Math.round(lineWidth / 2))
                .line({
                    cap: lineCap,
                    join: lineJoin
                })
                .shadowColor("transparent")
                .moveTo(pt1[0], pt1[1])
                .line({
                    to: [pt2[0], pt2[1]],
                    width: lineWidth
                })
                .strokeStyle(color)
                .strokeStyle(pitch.gradient || color)
                .stroke()
                .globalCompositeOperation('source-over')
                .globalAlpha(1.0)
                .closePath();
        },
        drawHistory : function(){
            if(config.fadeOldPitches && this.canvas_history){
                this.pitchLayer.scheduler.addAction(function () {
                    this.gtx_history.drawImage(this.canvas_bg,0,0);
                    this.gtx_bg.drawImage(this.canvas_bg,0,0);

                    this.canvas_bg.width = this.canvas_bg.width;
                    this.gtx_bg.beginPath()
                        .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                        .closePath();

                    this.gtx_bg.beginPath()
                        .fillStyle("rgba(0,0,0,0.1)")
                        .fillRect(0, 0, 1, 1)
                        .closePath();

                }, 0, this);
            }
        },
        drawStrikeZone : function (pitch) {
        	
            var that=this,
            	scalers=this.scalers,
            	sz = pitch.pitch.szTop && pitch.pitch.szBot ? pitch.pitch : scalers.strikeZone,
            	topLeftCorner = pitch.raster.pointOnGrid(-scalers.homePlateWidth / 2, sz.szTop, -scalers.homePlateFrontY),
                bottomRightCorner = pitch.raster.pointOnGrid(scalers.homePlateWidth / 2, sz.szBot, -scalers.homePlateFrontY),
                grid = [
                    [],
                    [],
                    []
                ],
                outliers = [],
                hotColdZones = scalers.mode !== '2d' && scalers.hotColdZones && this.pitchLayer.hotcold,
                zones;

            if (!hotColdZones) {
                this.drawNOHCStrikeZone(topLeftCorner, bottomRightCorner);
                return;
            }

            var count = 0,
                i = 0,
                zones = [].concat(this.pitchLayer.hotcold.sitModel && this.pitchLayer.hotcold.sitModel.zones || []);

            this.gtx_fg.beginPath()
                .fillStyle("rgba(0,0,0,0.1)")
                .fillRect(0, 0, 1, 1)
                .closePath();

            if (!zones.length) {
                this.drawNOHCStrikeZone(topLeftCorner, bottomRightCorner);
            }
            /*
             * Populate inner strike zone data
             * leaving over outlier data for later
             */
            while (zones.length && i < 3) {
                grid[i].push({
                    data: zones.shift(),
                    temp: zones.shift()
                });

                count += 1;

                if (count === 3) {
                    i += 1;
                    count = 0;
                }
            }

            // Populate outlier zones of strike zone data
            while (zones.length) {
                outliers.push({
                    data: zones.shift(),
                    temp: zones.shift()
                });
            }

            outliers.forEach(function (e, i) {
                var x,
                    y;

                switch (i) {
                    case 0:
                        x = topLeftCorner[0] - (scalers.szBorder * 2);
                        y = topLeftCorner[1] - (scalers.szBorder * 2);
                        break;

                    case 1:
                        x = topLeftCorner[0] - (scalers.szBorder * 2) + ((bottomRightCorner[0] - topLeftCorner[0] + (scalers.szBorder * 2) * 2) / 2);
                        y = topLeftCorner[1] - (scalers.szBorder * 2);
                        break;

                    case 2:
                        x = topLeftCorner[0] - (scalers.szBorder * 2);
                        y = topLeftCorner[1] - (scalers.szBorder * 2) + ((bottomRightCorner[1] - topLeftCorner[1] + (scalers.szBorder * 2) * 2) / 2);
                        break;

                    case 3:
                        x = topLeftCorner[0] - (scalers.szBorder * 2) + ((bottomRightCorner[0] - topLeftCorner[0] + (scalers.szBorder * 2) * 2) / 2);
                        y = topLeftCorner[1] - (scalers.szBorder * 2) + ((bottomRightCorner[1] - topLeftCorner[1] + (scalers.szBorder * 2) * 2) / 2);
                        break;

                    default:
                        // do nothing
                        break;
                }

                that.gtx_fg
                    .beginPath()
                    .shadowColor("transparent")
                    .lineWidth(1)
                    .fillStyle(e.data.color)
                    .fillRect(
                    x,
                    y,
                        (bottomRightCorner[0] - topLeftCorner[0] + (scalers.szBorder * 2) * 2) / 2,
                        (bottomRightCorner[1] - topLeftCorner[1] + (scalers.szBorder * 2) * 2) / 2
                )
                    .closePath();
            });

            this.gtx_fg
                .beginPath()
                .shadowColor("transparent")
                .clearRect(
                    topLeftCorner[0] - 1,
                    topLeftCorner[1] - 1,
                    bottomRightCorner[0] - topLeftCorner[0] + 2,
                    bottomRightCorner[1] - topLeftCorner[1] + 2
            )
                .closePath();
            
            grid.forEach(function (row, y) {
                row.forEach(function (zone, x) {
                	var coords={};
                    ([x, this.y]).forEach(function (e, i) {
	                    switch (e) {
	                        case 0:
	                            e = topLeftCorner[i];
	                            break;

	                        case 1:
	                            e = topLeftCorner[i] + ((bottomRightCorner[i] - topLeftCorner[i]) / 3);
	                            break;

	                        case 2:
	                            e = topLeftCorner[i] + (((bottomRightCorner[i] - topLeftCorner[i]) / 3) * 2);
	                            break;

	                        default:
	                            // do nothing!
	                            break;
	                    }

	                    i === 0 ? coords.x = e : coords.y = e;
	                });

                    that.gtx_fg
                        .beginPath()
                        .fillStyle(zone.data.color)
                        .fillRect(coords.x, coords.y, ((bottomRightCorner[0] - topLeftCorner[0]) / 3), ((bottomRightCorner[1] - topLeftCorner[1]) / 3))
                        .strokeStyle("rgba(127, 127, 127, .2)")
                        .lineWidth(2)
                        .strokeRect(coords.x, coords.y, ((bottomRightCorner[0] - topLeftCorner[0]) / 3), ((bottomRightCorner[1] - topLeftCorner[1]) / 3))
                        .closePath();
                }, { y: y });
            });
       
            this.isStrikeZoneDrawn = true;
        },
        drawNOHCStrikeZone : function (topLeftCorner, bottomRightCorner) {
        	var scalers=this.scalers;
            this.gtx_fg.beginPath()
                .shadowColor("transparent")
                .fillStyle("rgba(255, 255, 255, 0.3)")
                .fillRect(
                    topLeftCorner[0] - scalers.szBorder,
                    topLeftCorner[1] - scalers.szBorder,
                    bottomRightCorner[0] - topLeftCorner[0] + scalers.szBorder * 2,
                    bottomRightCorner[1] - topLeftCorner[1] + scalers.szBorder * 2
            )
                .clearRect(
                    topLeftCorner[0] - 1,
                    topLeftCorner[1] - 1,
                    bottomRightCorner[0] - topLeftCorner[0] + 2,
                    bottomRightCorner[1] - topLeftCorner[1] + 2
            )
                .fillStyle("rgba(0, 0, 0, 0.5)")
                .fillRect(
                topLeftCorner[0],
                topLeftCorner[1],
                    bottomRightCorner[0] - topLeftCorner[0],
                    bottomRightCorner[1] - topLeftCorner[1]
            )
                .strokeStyle("rgba(0, 0, 0, 0.6)")
                .strokeRect(
                    topLeftCorner[0] - scalers.szBorder,
                    topLeftCorner[1] - scalers.szBorder,
                    bottomRightCorner[0] - topLeftCorner[0] + scalers.szBorder * 2,
                    bottomRightCorner[1] - topLeftCorner[1] + scalers.szBorder * 2
            )
                .closePath();

            this.isStrikeZoneDrawn = true;
        },

        draw2DStrikeZone : function (pitch) {
            this.drawStrikeZone(pitch);
        },
        hideCanvas : function (cb) {
            if (this.hidden) {
                cb && cb();
                return;
            }
            this.hidden = true;
            this.canvas_bg.style.opacity = 0.1;
            this.canvas_fg.style.opacity = 0.1;
            if(this.canvas_history){
                this.canvas_history.style.opacity = 0.1;
            }
            if (cb) {
                setTimeout(cb, 500);
            }
        },

        showCanvas : function (cb) {
            if (!this.hidden) {
                cb && cb();
                return;
            }
            this.hidden = false;
            this.canvas_bg.style.opacity = 1;
            this.canvas_fg.style.opacity = 1;
            if(this.canvas_history){
                this.canvas_history.style.opacity = 0.5;
            }
            if (cb) {
                setTimeout(cb, 500);
            }

        },

        clear : function () {
            this.isStrikeZoneDrawn=false;
            this.gtx_bg.beginPath()
                .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                .closePath();
            
            this.hideCanvas();
            this.canvas_bg.width = this.canvas_bg.width;
            this.gtx_bg.beginPath()
                .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                .closePath();

            this.gtx_bg.beginPath()
                .fillStyle("rgba(0,0,0,0.1)")
                .fillRect(0, 0, 1, 1)
                .closePath();
            this.showCanvas();
            this.gtx_bg.beginPath()
                .clearRect(0, 0, this.canvas_bg.width, this.canvas_bg.height)
                .closePath();

            // now foreground
            this.gtx_fg.beginPath()
                .clearRect(0, 0, this.canvas_fg.width, this.canvas_fg.height)
                .closePath();
            
            this.resize();
            this.canvas_fg.width = this.canvas_fg.width;
            this.gtx_fg.beginPath()
                .clearRect(0, 0, this.canvas_fg.width, this.canvas_fg.height)
                .closePath();

            this.gtx_fg.beginPath()
                .fillStyle("rgba(0,0,0,0.1)")
                .fillRect(0, 0, 1, 1)
                .closePath();
            this.showCanvas();
            this.gtx_fg.beginPath()
                .clearRect(0, 0, this.canvas_fg.width, this.canvas_fg.height)
                .closePath();
        }
    };
    return RenderCanvas;
});
